import { FC } from "react";

import { Grid, GridItem } from "@chakra-ui/react";

import TimeOption from "./TimeOption";
import type { TTimeOptionsGridProps } from "./types";

const getKey = (time: string, i: number): string => `${time}-${i}`;

const TimeOptionsGrid: FC<TTimeOptionsGridProps> = ({ options, onSelect, selectedTime }) => {
  const columnCount = Math.ceil(Math.sqrt(options.length));

  return (
    <Grid templateColumns={`repeat(${columnCount}, 1fr)`} padding="0.5rem" gap="0.5rem" autoFlow="row">
      {options.map((option, index) => (
        <GridItem key={getKey(option.time, index)}>
          <TimeOption option={option} onSelect={onSelect} isSelected={option.time === selectedTime} />
        </GridItem>
      ))}
    </Grid>
  );
};
export default TimeOptionsGrid;
